import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import BtnGrid from '@App/components/BtnGrid/BtnGrid'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

const resultTypes = [
  { id: 'positive', label: 'Positive', icon: '/img/icons/results/positive.svg' },
  { id: 'negative', label: 'Negative', icon: '/img/icons/results/negative.svg' },
]

function ResultToggles({ activeResultTypes, setActiveResultTypes }) {
  const dispatch = useDispatch()

  const toggleResultTypes = useCallback((newActiveResultTypes) => {
    dispatch(setActiveResultTypes(newActiveResultTypes))
  }, [dispatch, setActiveResultTypes])

  useEffect(() => {
    if (activeResultTypes === undefined) {
      toggleResultTypes(resultTypes.map(resultType => resultType.id))
    }
  }, [activeResultTypes, toggleResultTypes])

  if (!activeResultTypes) return null

  return (
    <BtnGrid>
      {resultTypes.map((resultType) => {
        const active = activeResultTypes.includes(resultType.id)

        return (
          <IconBtnHor
            key={resultType.id}
            iconProps={{ icon: resultType.icon, size: '18px' }}
            inactive={!active}
            onClick={() => {
              const newActiveResultTypes = active
                ? activeResultTypes.filter(type => type !== resultType.id)
                : [...activeResultTypes, resultType.id]
              toggleResultTypes(newActiveResultTypes)
            }}
          >
            <span>{resultType.label}</span>
          </IconBtnHor>
        )
      })}
    </BtnGrid>
  )
}

export default ResultToggles
